// DO NOT EDIT MANUALLY
// This file was automatically generated by `scripts/MapboxStyles/process.ts`

import { MapboxStyleLayer } from '../types'

export const mapboxStyleGroupLayers_parking_calculator: MapboxStyleLayer[] = [
  {
    id: 'circle',
    type: 'circle',
    paint: {
      'circle-color': '#6d28d9',
      'circle-stroke-color': '#fdf4ff',
      'circle-stroke-opacity': 0.9,
      'circle-stroke-width': ['interpolate', ['linear'], ['zoom'], 16, 0, 20, 2],
      'circle-radius': ['interpolate', ['linear'], ['zoom'], 10, 0, 17, 3],
    },
  },
]
